import { render, staticRenderFns } from "./quotation-list.vue?vue&type=template&id=ca8221ca&scoped=true&"
import script from "./quotation-list.vue?vue&type=script&lang=js&"
export * from "./quotation-list.vue?vue&type=script&lang=js&"
import style0 from "./quotation-list.vue?vue&type=style&index=0&id=ca8221ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8221ca",
  null
  
)

export default component.exports